unit View.Modulos_Data_Base.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils;

type
  TFViewModulos_Data_BaseList = class(TForm)
    btNew: TButton;
    Modulos_Data_BaseDataset: TXDataWebDataSet;
    Modulos_Data_BaseDatasetid: TIntegerField;
    Modulos_Data_BaseDatasetaliado_id: TIntegerField;
    Modulos_Data_BaseDatasetmodulo_id: TIntegerField;
    Modulos_Data_BaseDatasetdata_base_id: TIntegerField;
    Modulos_Data_BaseDatasetcodigo_interno: TIntegerField;
    Modulos_Data_BaseDatasetexcluido: TBooleanField;
    Modulos_Data_BaseDatasetinclusao: TDateTimeField;
    Modulos_Data_BaseDatasetalteracao: TDateTimeField;
    Modulos_Data_BaseDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewModulos_Data_BaseList: TFViewModulos_Data_BaseList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModulos_Data_BaseList }

procedure TFViewModulos_Data_BaseList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewModulos_Data_BaseList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModulos_Data_BaseList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewModulos_Data_BaseList, AElementID, Result, @AfterCreate);
end;

procedure TFViewModulos_Data_BaseList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewModulos_Data_BaseList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewModulos_Data_BaseList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Modulos_Data_BaseDataset.Connection.Model.DefaultSchema.FindEntityType(Modulos_Data_BaseDataset.EntitySetName),
      Modulos_Data_BaseDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewModulos_Data_BaseList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Modulos_Data_BaseDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewModulos_Data_BaseList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.modulos_data_base.list.pagination.info');
  btNew := TButton.Create('view.modulos_data_base.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.modulos_data_base.list.table');
  cbPageSize := TComboBox.Create('view.modulos_data_base.list.cbPageSize');
  edSearch := TEdit.Create('view.modulos_data_base.list.search');
  lcPaginator := TListControl.Create('view.modulos_data_base.list.pagination');
  Modulos_Data_BaseDataset := TXDataWebDataSet.Create(Self);
  Modulos_Data_BaseDatasetid := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetaliado_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetmodulo_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetdata_base_id := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetcodigo_interno := TIntegerField.Create(Self);
  Modulos_Data_BaseDatasetexcluido := TBooleanField.Create(Self);
  Modulos_Data_BaseDatasetinclusao := TDateTimeField.Create(Self);
  Modulos_Data_BaseDatasetalteracao := TDateTimeField.Create(Self);
  Modulos_Data_BaseDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Modulos_Data_BaseDataset.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetid.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetaliado_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetmodulo_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetdata_base_id.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetcodigo_interno.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetexcluido.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetinclusao.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetalteracao.BeforeLoadDFMValues;
  Modulos_Data_BaseDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewModulos_Data_BaseList';
    Left := 0;
    Top := 0;
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.Transparent := True;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.TabOrder := 0;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modulo_id';
      Title := 'modulo_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.TabOrder := 3;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Modulos_Data_BaseDataset.SetParentComponent(Self);
    Modulos_Data_BaseDataset.Name := 'Modulos_Data_BaseDataset';
    Modulos_Data_BaseDataset.EntitySetName := 'Modulos_Data_Base';
    Modulos_Data_BaseDataset.Connection := DMConnection.ApiConnection;
    Modulos_Data_BaseDataset.Left := 72;
    Modulos_Data_BaseDataset.Top := 144;
    Modulos_Data_BaseDatasetid.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetid.Name := 'Modulos_Data_BaseDatasetid';
    Modulos_Data_BaseDatasetid.FieldName := 'id';
    Modulos_Data_BaseDatasetid.Required := True;
    Modulos_Data_BaseDatasetaliado_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetaliado_id.Name := 'Modulos_Data_BaseDatasetaliado_id';
    Modulos_Data_BaseDatasetaliado_id.FieldName := 'aliado_id';
    Modulos_Data_BaseDatasetaliado_id.Required := True;
    Modulos_Data_BaseDatasetmodulo_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetmodulo_id.Name := 'Modulos_Data_BaseDatasetmodulo_id';
    Modulos_Data_BaseDatasetmodulo_id.FieldName := 'modulo_id';
    Modulos_Data_BaseDatasetmodulo_id.Required := True;
    Modulos_Data_BaseDatasetdata_base_id.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetdata_base_id.Name := 'Modulos_Data_BaseDatasetdata_base_id';
    Modulos_Data_BaseDatasetdata_base_id.FieldName := 'data_base_id';
    Modulos_Data_BaseDatasetdata_base_id.Required := True;
    Modulos_Data_BaseDatasetcodigo_interno.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetcodigo_interno.Name := 'Modulos_Data_BaseDatasetcodigo_interno';
    Modulos_Data_BaseDatasetcodigo_interno.FieldName := 'codigo_interno';
    Modulos_Data_BaseDatasetcodigo_interno.Required := True;
    Modulos_Data_BaseDatasetexcluido.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetexcluido.Name := 'Modulos_Data_BaseDatasetexcluido';
    Modulos_Data_BaseDatasetexcluido.FieldName := 'excluido';
    Modulos_Data_BaseDatasetexcluido.Required := False;
    Modulos_Data_BaseDatasetinclusao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetinclusao.Name := 'Modulos_Data_BaseDatasetinclusao';
    Modulos_Data_BaseDatasetinclusao.FieldName := 'inclusao';
    Modulos_Data_BaseDatasetinclusao.Required := False;
    Modulos_Data_BaseDatasetalteracao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetalteracao.Name := 'Modulos_Data_BaseDatasetalteracao';
    Modulos_Data_BaseDatasetalteracao.FieldName := 'alteracao';
    Modulos_Data_BaseDatasetalteracao.Required := False;
    Modulos_Data_BaseDatasetexclusao.SetParentComponent(Modulos_Data_BaseDataset);
    Modulos_Data_BaseDatasetexclusao.Name := 'Modulos_Data_BaseDatasetexclusao';
    Modulos_Data_BaseDatasetexclusao.FieldName := 'exclusao';
    Modulos_Data_BaseDatasetexclusao.Required := False;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Modulos_Data_BaseDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Modulos_Data_BaseDataset.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetid.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetaliado_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetmodulo_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetdata_base_id.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetcodigo_interno.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetexcluido.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetinclusao.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetalteracao.AfterLoadDFMValues;
    Modulos_Data_BaseDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
